// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"LoadingScreen_loaderWrapper__kkSmC"};